"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
exports.default = axios_1.default.create({
    baseURL: process.env.REACT_APP_AXIOS_BASE_URL,
    responseType: 'json'
});
//# sourceMappingURL=api.js.map